import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import Header from './Components/Header/Header';
import TrustedBy from './Components/TrustedBy/TrustedBy';
import Nav from './Components/Nav/Nav';
import About from './Components/About/About';
import Experience from './Components/Experience/Experience';
import Services from './Components/Services/Services';
import Portfolio from './Components/Portfolio/Portfolio';
import Testimonials from './Components/Testimonials/Testimonials';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';
import ScrollProgressBar from './Components/ScrollProgressbar/ScrollProgressBar';
import Chatbot from './Components/Chatbot/Chatbot';
import NeonCursor from './Components/NeonCursor/NeonCursor';


const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
};

const App = () => {
  // Track which sections users visit
  useEffect(() => {
    const sections = document.querySelectorAll('section[id]');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackEvent('section_view', {
              section_name: entry.target.id,
              page_location: window.location.href,
            });
          }
        });
      },
      { threshold: 0.4 }
    );
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  // Track portfolio project clicks
  useEffect(() => {
    const handleProjectClick = (e) => {
      const card = e.target.closest('.portfolio__item');
      if (card) {
        const title = card.querySelector('h3')?.innerText || 'Unknown Project';
        trackEvent('project_click', { project_name: title });
      }
    };
    document.addEventListener('click', handleProjectClick);
    return () => document.removeEventListener('click', handleProjectClick);
  }, []);

  return (
    // reducedMotion="user" makes every framer-motion animation honour the OS "reduce motion" setting
    <MotionConfig reducedMotion="user">
      <NeonCursor />
      <ScrollProgressBar />
      <Header />
      <Nav />
      <About />
      <Experience />
      <Services />
      <Portfolio />
      <TrustedBy />
      <Testimonials />
      <Contact />
      <Footer />
      <Chatbot />
    </MotionConfig>
  )
}

export default App
